import React from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { Icon } from '@PetSureAustralia/petsure-react-ui-library/distLib/components';
import { HelpCentreTopics } from '../../../constants/helpCentreTopics';
import { TopicsPropType } from '../../../propTypes/faqs';

import './topicsNavigatorBar.scss';

export const TopicsNavigatorBar = ({ activeTopic = 'popular', layout = 'horizontal', topics = HelpCentreTopics }) => {
  const navigate = useNavigate();

  const HandleTopicNavigation = ({ topicKey, topicDef }) => {
    navigate(topicDef.url);
  };

  return (
    <nav
      className={`topicsNavigatorBar ${layout}Layout`}
      aria-label="Help topics navigation"
    >
      <ul>
        {Object.entries(topics).map(([topicKey, topicDef]) => {
          const { heading, icon } = topicDef;

          return (
            <li key={topicKey}>
              {activeTopic === topicKey ? (
                <span className="tab activeTab">
                  <Icon icon={icon} />
                  <span className="labelText">{heading}</span>
                  {layout === 'vertical' && <Icon icon="arrow-right2" />}
                </span>
              ) : (
                <button
                  className="tab"
                  type="button"
                  onClick={() => HandleTopicNavigation({ topicKey, topicDef })}
                >
                  <Icon icon={icon} />
                  <span className="labelText">{heading}</span>
                </button>
              )}
            </li>
          );
        })}
      </ul>
    </nav>
  );
};

TopicsNavigatorBar.propTypes = {
  activeTopic: TopicsPropType,
  layout: PropTypes.oneOf(['horizontal', 'vertical']),
  // eslint-disable-next-line react/forbid-prop-types
  topics: PropTypes.any
};
